// extracted by mini-css-extract-plugin
module.exports = {"ReactQuillDisplay":"ReactQuillDisplay_ReactQuillDisplay__3m5cV","click-zoom":"ReactQuillDisplay_click-zoom__1QSvi"};